import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getGeometry() {
    return new Promise((resolve, reject) => {
      api
        .get("geometry/list")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  }
};
